import { createSelector } from 'reselect';

import { getCompany } from './company.selectors';

const selectRootMobileAppRelease = createSelector(
  getCompany,
  ({ mobileAppRelease }) => mobileAppRelease,
);

export const selectMobileAppReleaseConfig = createSelector(
  selectRootMobileAppRelease,
  ({ config }) => config,
);

export const selectMobileAppReleaseEvents = createSelector(
  selectRootMobileAppRelease,
  ({ events }) => events,
);

export const selectIosPushCertificateStatus = createSelector(
  selectRootMobileAppRelease,
  ({ iosPushCertificate }) => iosPushCertificate,
);
